import React from 'react';
import { useRouter } from 'next/router';

import { CanvasItem } from 'themes/canvas/components/Item/Item';

import { useBnplPromo } from 'hooks/bnpl/useBnplPromo';

import { BuyNowPayLaterPromo } from 'routes/invoices/components/BuyNowPayLaterPromo/BuyNowPayLaterPromo';
import { PackageItem } from 'routes/packages/types';

import { getBnplUnitPriceFromStringDollars } from 'utils/bnplUtils';

import s from './Package.module.css';

type PackageProps = {
  package: PackageItem;
};

const Package = ({ package: packageItem }: PackageProps) => {
  const router = useRouter();

  const { name, description, price, items } = packageItem;

  const { isEnabled, bnplCapabilities } = useBnplPromo();
  const bnplUnitPrice = isEnabled
    ? getBnplUnitPriceFromStringDollars(price)
    : undefined;

  const onPackageClick = () => {
    void router.push('/contact');
  };

  return (
    <CanvasItem
      title={name}
      listView
      separator
      button={
        <CanvasItem.Button
          onClick={onPackageClick}
          title={`Book ${name}`}
          type="button"
          name="Book"
          className={s.actionButton}
        >
          <span className={s.buttonText}>Contact to purchase</span>
        </CanvasItem.Button>
      }
    >
      <p className={s.summary}>{description}</p>
      <div className={s.priceContainer}>
        <p className={s.price}>
          {price} {bnplUnitPrice ? 'or' : ''}
        </p>
        {bnplUnitPrice ? (
          <BuyNowPayLaterPromo
            unitAmount={bnplUnitPrice}
            textAlign="left"
            paymentMethodTypes={bnplCapabilities}
          />
        ) : null}
      </div>
      <ul>
        {items.map((item) => (
          <li key={item.token}>
            {item.quantity}x {item.name}
          </li>
        ))}
      </ul>
    </CanvasItem>
  );
};

export { Package };
